import * as React from 'react'
import { Settings } from '../../services/AppSettingsService';
import { queryNoTracking } from '../../services/DataService';
import { accentUtils, def, from } from '../../services/HelperService';
import { AccentSpinner } from '../AccentSpinner';
import { AccentComboUnbound } from '../unbound/AccentComboUnbound';
const query_PrintSetting_Select = queryNoTracking("PrintSetting_Select");

export const PrintSettingSelection = props => {
    const documentTypeFilter = props.type;
    const defaultValue = def(props.defaultValue, Settings.GetAppSettings().DefaultPrintSettings);
    const [data, setData] = React.useState(null);
    const [filteredData, setFilteredData] = React.useState(null);

    const onChanged = React.useCallback(e => {
        props.onChange(e);
        Settings.SetAppSettings({ DefaultPrintSettings: e });
    }, [props]);

    // Filter data whenever the original data or type changes
    React.useEffect(() => {
        if (data) {
            if (documentTypeFilter) {
                const filtered = from(data).where(item => item.Type === documentTypeFilter).toArray();
                setFilteredData(filtered);
            } else {
                setFilteredData(data);
            }
        }
    }, [data, documentTypeFilter]);

    // Load initial data
    React.useEffect(() => {
        query_PrintSetting_Select.getAll().then(r => {
            const defaultExists = !accentUtils.isEmpty(defaultValue) && from(r).any(i => i.ID == defaultValue);
            setData(r);
            if (props.onReady)
                props.onReady(defaultExists ? defaultValue : null);
        });
    }, []);

    if (filteredData == null) return <AccentSpinner />;

    return (
        <AccentComboUnbound
            displayField="Name"
            valueField="ID"
            defaultValue={defaultValue}
            onChange={onChanged}
            label="Product Settings"
            data={filteredData}
        />
    );
};